<template>
  <div class="FreightReview">
    <el-radio-group v-model="pageShow" size="small" @change="changePageShow">
      <el-radio-button label="1">运费审核</el-radio-button>
      <el-radio-button label="2">扣款列表</el-radio-button>
    </el-radio-group>

    <el-form
        class="custom-formScreen"
        :model="formScreen"
        ref="formScreen"
        label-width="4.8vw"
        inline
    >
      <el-form-item label="分公司" prop="branchCompanyId" v-show="pageShow === '1'">
        <el-select v-model="formScreen.branchCompanyId" filterable placeholder="请选择" @change="selectChange">
          <el-option
              v-for="item in listBranch"
              :key="item.id"
              :label="item.companyFullName"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子公司" prop="companyId" v-show="pageShow === '1'">
        <el-select v-model="formScreen.companyId" filterable placeholder="请选择">
          <el-option
              v-for="item in listSon"
              :key="item.id"
              :label="item.companyFullName"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理状态" prop="status" v-show="pageShow === '2'">
        <el-select v-model="formScreen.status">
          <el-option
              v-for="item in listHandleStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startTimeString">
        <el-date-picker
            v-model="formScreen.startTimeString"
            align="right"
            type="date"
            placeholder="选择开始日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTimeString">
        <el-date-picker
            v-model="formScreen.endTimeString"
            align="right"
            type="date"
            placeholder="选择结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item prop="searchString" label=" " style="width: 40%">
        <el-input
            v-model.trim="formScreen.searchString"
            placeholder="请输入订单号/订单ID/国际单号"
            style="width: calc(100% - 140px);"
        ></el-input>
        <el-button type="primary" @click="changePageShow" style="margin-left: 10px;">搜索</el-button>
        <el-button type="primary" @click="resetForm('formScreen')">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row
        style="padding-bottom: 20px;"
        type="flex"
        justify="space-between"
        align="middle"
        v-show="pageShow === '2'"
    >
      <el-button type="primary" @click="ExportClick">导入运费</el-button>
      <el-row style="width: 700px;" type="flex" justify="space-between" align="middle">
        <div style="flex: 1;">平台费总金额：{{ totalPlatformFee }}</div>
        <div style="flex: 1;">分公司可用总金额：{{ totalBuckleBalance }}</div>
        <div style="flex: 1;">分公司实际总金额：{{ totalBalance }}</div>
      </el-row>
    </el-row>

    <!-- S: 运费审核 -->
    <el-table
        :data="listTable"
        :header-cell-style="{ textAlign: 'center' }"
        border
        max-height="600"
        v-show="pageShow === '1'"
        v-loading="loadingTable"
    >
      <el-table-column prop="imageUrl" label="产品主图" align="center" width="80">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right">
            <img :src="scope.row.imageUrl" class="prduct_img" alt/>
            <div class="scope_img" slot="reference">
              <img :src="scope.row.imageUrl" alt/>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="channelName" label="渠道名称" align="center" width="80"></el-table-column>
      <el-table-column prop="channelWay" label="渠道方式" align="center" width="80"></el-table-column>
      <el-table-column prop="countryName" label="目的国家" align="center" width="80"></el-table-column>
      <el-table-column prop label="尺寸" align="center" width="280">
        <template slot-scope="scope">
          <div style="display: flex;align-items: center;">
            <el-input class="cus-inp" v-model="scope.row.length"></el-input>
            <span style="margin: 0 10px;">X</span>
            <el-input class="cus-inp" v-model="scope.row.width"></el-input>
            <span style="margin: 0 10px;">X</span>
            <el-input class="cus-inp" v-model="scope.row.height"></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop label="材积系数" align="center" width="120">
        <template slot-scope="scope">
          <el-select v-model="scope.row.volumeValue" filterable>
            <el-option
                v-for="item in listNumer"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="scope.row.volumeValue"></el-input> -->
        </template>
      </el-table-column>
      <el-table-column prop="volumeWeight" label="材积重" align="center" width="100">
        <template slot-scope="scope">
          <div>{{ calcVolumeWeight(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="channelVolumeWeight" label="渠道材积重" align="center" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.channelVolumeWeight"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="channelWeight" label="重量" align="center" width="80"></el-table-column>
      <el-table-column prop="orderChannelWeight" label="渠道重量" align="center" width="80">
        <template slot-scope="scope">
          <el-input v-model="scope.row.orderChannelWeight"></el-input>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="actualWeight" label="出库计费重" align="center" width="100">
        <template slot-scope="scope">
          <div>{{ calcActualWeight(scope.row) }}</div>
        </template>
      </el-table-column>-->
      <el-table-column prop="channelActualWeight" label="渠道计费重" align="center" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.channelActualWeight"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="shipping" label="运费" align="center" width="100"></el-table-column>
      <el-table-column prop="otherShipping" label="其它" align="center" width="100">
        <template slot-scope="scope">
          <el-input class="cus-inp" v-model="scope.row.otherShipping"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="总费用" align="center" width="100">
        <template slot-scope="scope">
          <div>{{ Number(scope.row.shipping) + Number(scope.row.otherShipping) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="transferOrderNumber" label="转单号" align="center" width="300">
        <template slot-scope="scope">
          <el-input class="cus-inp" v-model="scope.row.transferOrderNumber"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" width="200">
        <template slot-scope="scope">
          <el-input v-model="scope.row.remark"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="conveyNumber" label="国际运单号" align="center" width="120"></el-table-column>
      <el-table-column prop="orderId" width="240" label="订单号/订单ID" align="left">
        <template slot-scope="scope">
          <div>订单号：{{ scope.row.amazonOrderId }}</div>
          <div>订单ID：{{ scope.row.orderId }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="purchaseDate" width="180" label="时间" align="center"></el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="120">
        <template slot-scope="scope">
          <el-button
              :type="scope.row.shippingIsUpdate ? 'warning' : 'primary'"
              @click="saveInfo(scope.row)"
          >保存运费
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- E: 运费审核 -->

    <!-- S: 扣款列表 -->
    <el-table
        :data="listTable2"
        :header-cell-style="{ textAlign: 'center' }"
        border
        max-height="630"
        v-show="pageShow === '2'"
    >
      <el-table-column prop="amazonOrderId" label="客户订单号" align="center" width="200"></el-table-column>
      <el-table-column prop="conveyNumber" label="国际运单号" align="center" width="240"></el-table-column>
      <el-table-column prop="status" label="处理状态" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 0">处理中</div>
          <div style="color: green;" v-else-if="scope.row.status === 1">处理成功</div>
          <div style="color: red;" v-else-if="scope.row.status === 2">运单重复</div>
          <div style="color: red;" v-else-if="scope.row.status === 3">运单负值</div>
          <div style="color: red;" v-else-if="scope.row.status === 4">不存在</div>
          <div style="color: red;" v-else-if="scope.row.status === 5">运单异常</div>
        </template>
      </el-table-column>
      <el-table-column prop="channelWay" label="渠道方式" align="center"></el-table-column>
      <el-table-column prop="trackNumber" label="跟踪号" align="center" min-width="200"></el-table-column>
      <el-table-column prop="channelVolumeWeight" label="材积重" align="center" width="100"></el-table-column>
      <el-table-column prop="orderChannelWeight" label="重量" align="center" width="100"></el-table-column>
      <el-table-column prop="channelActualWeight" label="渠道计费重" align="center"></el-table-column>
      <el-table-column prop="shipping" label="运费" align="center"></el-table-column>
      <el-table-column prop="otherShipping" label="其它" align="center"></el-table-column>
      <el-table-column prop="roleName" label="操作人" align="center"></el-table-column>
      <el-table-column prop="createTime" label="导入时间" align="center" width="200"></el-table-column>
    </el-table>
    <!-- E: 扣款列表 -->
    <el-row class="pagination-box" type="flex" justify="center" align="middle">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 200, 300]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </el-row>

    <el-dialog
        title="导入运费"
        :visible.sync="dialogVisible"
        width="30%"
        @close="handleUploadExcelDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        destroy-on-close
    >
      <el-row type="flex" align="middle">
        <upload-excel-component :on-success="handleUploadExcelSuccess"/>
        <el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button>
      </el-row>
      <div class="file-box">
        <div v-for="(item, index) in listFile" :key="index">{{ `${ index + 1 }. ${ item.fileName }` }}</div>
      </div>
      <div slot="footer">
        <el-button
            size="small"
            @click="handleUploadExcelSubmit"
            :disabled="StatusDs"
            :loading="loadingStatus === 'handleExcel'"
        >确认扣费
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Baseurl, ajaxPost } from "@/api/api/api";
import UploadExcelComponent from '@/components/UploadExcel/index.vue'

export default {
  name: "FreightReview",
  components: {
    UploadExcelComponent,
  },
  data() {
    return {
      str: "",
      UserInfo: {},
      page: 1,
      size: 20,
      total: 0,
      pageShow: '1',
      listBranch: [],
      listSon: [],
     
      formScreen: {
        startTimeString: "",
        endTimeString: "",
        searchString: "",
        branchCompanyId: "",
        companyId: "",
        status: '',
      },
      listHandleStatus: [
        { value: 0, label: '处理中' },
        { value: 1, label: '处理成功' },
        { value: 2, label: '运单重复' },
        { value: 3, label: '运单负值' },
        { value: 4, label: '不存在' },
        { value: 5, label: '运单异常' },
      ],
      listTable: [],
      listTable2: [],
      dialogVisible: false,
      listFile: [],
      loadingStatus: '',
       StatusDs:false,
      totalBalance: '',
      totalBuckleBalance: '',
      totalPlatformFee: '',

      listNumer: [
        { value: 6500, label: '6500' },
        { value: 7000, label: '7000' },
        { value: 7500, label: '7500' },
        { value: 8000, label: '8000' },
        { value: 8500, label: '8500' },
        { value: 9000, label: '9000' },
        { value: 9500, label: '9500' },
        { value: 10000, label: '10000' },
        { value: 10500, label: '10500' },
        { value: 11000, label: '11000' },
        { value: 11500, label: '11500' },
        { value: 12000, label: '12000' },
      ],
      loadingTable: false,
    };
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    this.changePageShow()
    this.getBranchCompanyList();
    this.str = JSON.parse(localStorage.getItem("role"));
  },
  methods: {
    handleSizeChange(val) {
      this.size = val;
      this.changePageShow();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.changePageShow();
    },
    resetForm(formName) {
      this.page = 1
      this.$refs[formName].resetFields();
      this.listSon = [];
      this.changePageShow();
    },
    selectChange(id) {
      this.formScreen.companyId = "";
      this.listSon = [];
      this.getSonCompanyList(id);
    },
    getBranchCompanyList() {
      const API = Baseurl + "logisticsController/getAllBranchCompany";
      ajaxPost(API).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listBranch = data;
        }
      });
    },
    getSonCompanyList(id) {
      const API = Baseurl + "logisticsController/getAllSubCompanyById";
      const paramsData = { id };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listSon = data;
        }
      });
    },
    getListTable() {
      const API = Baseurl + "logisticsController/getFreightAuditList";
      const paramsData = {
        page: this.page,
        size: this.size,
        ...this.formScreen,
      };
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingTable = false
        const { code, data } = res.data;
        if (code === 200) {
          this.total = data.total;
          data.list.forEach(item => item.volumeValue = 8000)
          this.listTable = data.list;
        }
      });
    },
    saveInfo(row) {
      const {
        id, actualWeight, channelActualWeight,
        shipping, otherShipping, remark, length, width, height, volumeValue, volumeWeight, channelVolumeWeight, orderChannelWeight, transferOrderNumber
      } = row
      const handleRequest = async () => {
        const API = Baseurl + "logisticsController/saveFreightAuditList";
        const paramsData = {
          id,
          actualWeight,
          channelActualWeight,
          shipping,
          otherShipping,
          remark,
          length,
          width,
          height,
          volumeValue,
          volumeWeight,
          channelVolumeWeight,
          orderChannelWeight,
          transferOrderNumber,
          shippingIsUpdate: 1,
        };
        const { data: { code } } = await ajaxPost(API, paramsData);
        if (code === 200) {
          this.$message.success("操作成功");
          this.getListTable()
        } else {
          this.$message.error("操作有误");
        }
      };
      this.$confirm("确定要保存该数据吗？", "提示").then(() => {
        handleRequest();
      });
    },
    calcVolumeWeight(row) {
      const { length, width, height, volumeValue } = row
      const result = ((length * width * height) / volumeValue)
      row.volumeWeight = Number(result).toFixed(3)
      return Number(result).toFixed(3)
    },
    calcActualWeight(row) {
      const { VolumeWeight, channelWeight } = row
      const result = VolumeWeight > channelWeight ? VolumeWeight : channelWeight
      row.actualWeight = Number(result)
      return Number(result)
    },
    changePageShow(e) {
      if (e) {
        this.page = 1
        this.size = 20
        this.total = 0
      }
      if (this.pageShow === '1') {
        // 运费审核
        this.getListTable();
      } else if (this.pageShow === '2') {
        // 扣款列表
        this.getBranchMoney()
        this.getlistTable()
      }
    },
    handleUploadExcelDialogClose() {
      this.listFile = []
      this.getListTable()
    },
    handleUploadExcelSuccess({ results, fileName }) {
      const dataArr = results.map(item => ({
        amazonOrderId: item.客户单号,
        conveyNumber: item.国际运单号,
        channelWay: item.渠道方式,
        trackNumber: item.跟踪号,
        channelVolumeWeight: item.材积重,
        orderChannelWeight: item.重量,
        channelActualWeight: item.渠道计费重,
        shipping: item.运费,
        otherShipping: item.其他,
      }))

      const temporaryObj = { fileName, dataArr }
      this.listFile.push(temporaryObj)
    },
    ExportClick(){
            this.dialogVisible = true;
            this.loadingStatus = '';
            this.StatusDs = false;
    },
    async handleUploadExcelSubmit() {
      const allShippingApplies = this.listFile.reduce((original, item) => [...original, ...item.dataArr], [])
      const API = Baseurl + 'logisticsController/importShippingAndAutoDeduction'
      const batchSize = 100 // 每批处理100条
      const total = allShippingApplies.length
      let successCount = 0
      let failedCount = 0
      let currentBatch = 0

      this.loadingStatus = 'handleExcel';
      this.StatusDs = true;

      // 分批处理
      for (let i = 0; i < total; i += batchSize) {
        currentBatch++
        const batch = allShippingApplies.slice(i, i + batchSize)
        const paramsData = {
          shippingApplies: batch,
          roleId: this.str.rid,
        }

        try {
          const res = await ajaxPost(API, paramsData)
          const { code } = res.data

          if (code === 200) {
            successCount += batch.length
            this.$message.success(`批次 ${currentBatch}/${Math.ceil(total / batchSize)} 导入成功 (${successCount}/${total})`)
          } else {
            failedCount += batch.length
            this.$message.error(`批次 ${currentBatch} 失败: ${res.data.data}`)
          }
        } catch (error) {
          failedCount += batch.length
          this.$message.error(`批次 ${currentBatch} 请求失败: ${error.message}`)
        }

        // 更新进度提示
        const processed = Math.min(i + batchSize, total)
        this.$message.info(`正在处理: ${processed}/${total} (成功: ${successCount}, 失败: ${failedCount})`)
      }

      // 全部处理完成
      this.loadingStatus = ''
      this.StatusDs = false
      this.dialogVisible = false

      if (successCount > 0) {
        this.$message.success(`导入完成！成功: ${successCount}, 失败: ${failedCount}`)
        this.getListTable()
      } else {
        this.$message.error(`导入失败！共 ${failedCount} 条数据失败`)
      }
    },
    getBranchMoney() {
      const API = Baseurl + 'logisticsController/selectAllBranchCompanyTotalMoney'
      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.totalBuckleBalance = data.totalBuckleBalance
          this.totalBalance = data.totalBalance
          this.totalPlatformFee = data.totalPlatformFee
        }
      })
    },
    getlistTable() {
        //  this.loadingStatus = '';
        //     this.StatusDs = false;
      const API = Baseurl + 'logisticsController/selectShippingApplyList'
      const paramsData = {
        page: this.page,
        size: this.size,
        status: this.formScreen.status,
        startTimeString: this.formScreen.startTimeString,
        endTimeString: this.formScreen.endTimeString,
        searchString: this.formScreen.searchString,
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.total = data.total
          this.listTable2 = data.list
        }
      })
    },
    downloadTemplate() {
      const a = document.createElement('a')
      a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E8%BF%90%E8%B4%B9%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls'
      a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E8%BF%90%E8%B4%B9%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls'
      a.click()
      this.$message.success('正在下载...')
    },
  },
};
</script>

<style lang="scss" scoped>
.FreightReview {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }

  .scope_img {
    img {
      width: 60px;
      height: 60px;
    }
  }

  .prduct_img {
    width: 500px;
    height: 500px;
  }

  .file-box {
    padding-top: 20px;
  }
}
</style>
